import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import {
  ChevronLargeUp,
  ChevronLargeDown,
  WarningTriangleFilled,
  CompletedCircle,
} from 'AppSrc/core/components/common/svg-icons';
import {
  WORK_INFORMATION_ITEMS,
  APPROVERS_SECTION,
} from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/section-constants';
import {
  VIEW_TYPE_VIEW_CRQ_WITH_TICKS_AND_ERRORS,
  VIEW_TYPE_VIEW_CRQ_STANDARD,
} from 'AppSrc/core/components/view-crq-screen/view-crq-constants';
import {
  formDataShape,
} from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';

const nonChangeTextMap = {
  [WORK_INFORMATION_ITEMS]: 'Add/Change',
  [APPROVERS_SECTION]: 'Add',
};

// we mostly want this text to be "Change" but not always...
const getChangeText = (sectionId) => {
  const nonChangeText = nonChangeTextMap[sectionId];
  return nonChangeText ? nonChangeText : 'Change';
};

const getSvg = (sectionHasErrors, summarySectionRead, isChangeAnalyst, isCircuitCheck, sectionId) => {
  if (sectionHasErrors || (isChangeAnalyst === true && isCircuitCheck === '10500' && (sectionId === 'WORK_INFORMATION_ITEMS'))) {
    if (isChangeAnalyst === true && isCircuitCheck === '10500' && (sectionId === 'WORK_INFORMATION_ITEMS')) {
      const isWorkInfoItem = window.localStorage.getItem('isInfoItem');
      if (isWorkInfoItem === 'true') {
        return CompletedCircle;
      }
      // else {
      return WarningTriangleFilled;
      // }
    }
    return WarningTriangleFilled;
  }
  if (summarySectionRead && isChangeAnalyst === true && isCircuitCheck === '10500') {
    return null;
  }
  if (summarySectionRead && isChangeAnalyst === true && isCircuitCheck !== '10500') {
    return CompletedCircle;
  }
  if (summarySectionRead && isChangeAnalyst === false) {
    return CompletedCircle;
  }
  // we expoect this to sometimes return null;
  return null;
};





const SectionSummaryHeaderConnect = ({ // Changing method Name to wrap within Connect
  open,
  toggleOpen,
  sectionIndex,
  sectionId,
  sectionTitle,
  navigateToSection,
  viewType,
  summarySectionRead,
  sectionHasErrors,
  formData, // Getting formData as an extra props for checking in this component
  isChangeAnalyst, // Getting isChangeAnalyst as an extra props for checking in this component
  // assign, // adding for graying out the button
  changeAnalystCircuitCheckID, // adding for graying out the button
  userLoggedIn, // adding for graying out the button
  network, // for use in rescheduling
  impactValue, // for use in rescheduling
  hasReferenceCRQ,
}) => {
  const options = {
    navToSectionIndex: sectionIndex,
    navToSectionId: sectionId,
    returnToCurrentSection: true,
  };


  const isCircuitCheck = formData.statusReason; // Extracting statusReason
  const isStatus = formData.status; // Extracting status
  // const isRiskValue = formData.riskValue; // Extracting riskValue

  const SvgComponent = getSvg(sectionHasErrors, summarySectionRead, isChangeAnalyst, isCircuitCheck, sectionId);

  const baseClassName = 'section-summary-header';
  const classNames = [
    baseClassName,
    `${baseClassName}-${viewType}`,
  ];

  const className = classNames.join(' ');

  const isInfoItem = window.localStorage.getItem('isInfoItem');


  return (
    <div className={className}>
      <button
        type="button"
        onClick={() => toggleOpen(sectionIndex)}
        className="section-title"
      >
        {sectionTitle}
      </button>
      {
        // if isChangeAnalyst true and statusReason='10500' check for section ID 'WORK_INFORMATION_ITEMS'and 'APPROVERS_SECTION' and show add/change button
        isCircuitCheck === '10500'
          ? (isChangeAnalyst === true && (sectionId === 'WORK_INFORMATION_ITEMS' || sectionId === 'APPROVERS_SECTION')) && (
            navigateToSection && (
            <OptionButton
              disabled={((changeAnalystCircuitCheckID && userLoggedIn !== changeAnalystCircuitCheckID) || (!changeAnalystCircuitCheckID) || (changeAnalystCircuitCheckID === null)) ? true : false}
              onClick={navigateToSection}
              option={options}
              className={((changeAnalystCircuitCheckID && userLoggedIn !== changeAnalystCircuitCheckID) || (!changeAnalystCircuitCheckID) || (changeAnalystCircuitCheckID === null)) ? 'edit-section-assign' : 'edit-section'}
            >
                {getChangeText(sectionId)}
            </OptionButton>
            ))
          : (navigateToSection && isChangeAnalyst === true && (isCircuitCheck !== 'PostponedCRQ' && isCircuitCheck !== '30300')) && ( // if isChangeAnalyst true functionality to remain same
            <OptionButton
              onClick={navigateToSection}
              option={options}
              className={((sectionId === 'START_AND_END_DATE') && (hasReferenceCRQ() === true) && (network === 'mobile')) ? 'hidden' : 'edit-section'}
            >
              {getChangeText(sectionId)}
            </OptionButton>
          )
      }
      {/* {
        isStatus === '3' && (
          (isCircuitCheck === '30300' && network === 'fixed') || (isCircuitCheck === 'PostponedCRQ' && network === 'mobile') && (
            sectionId !== 'CHANGE_DETAILS' && (
              navigateToSection && (
                <OptionButton
                  onClick={navigateToSection}
                  option={options}
                  className="edit-section"
                >
                  {getChangeText(sectionId)}
                </OptionButton>
              ))))
      } */}
      {
        isCircuitCheck === '30300' && (
          (isStatus === '3' && sectionId !== 'CHANGE_TYPE' && network === 'fixed') && (
            navigateToSection && (
              <OptionButton
                onClick={navigateToSection}
                option={options}
                className="edit-section"
              >
                {getChangeText(sectionId)}
              </OptionButton>
            )))
      }
      {
        ((isChangeAnalyst === true && isCircuitCheck === 'PostponedCRQ' && isStatus === '3' && network === 'mobile')) && (
          sectionId !== 'CHANGE_TYPE' && (
            navigateToSection && (
              <OptionButton
                onClick={navigateToSection}
                option={options}
                className="edit-section"
              >
                {getChangeText(sectionId)}
              </OptionButton>
            )))
      }
      {
        // only show the change button if navigateToSection has been provided
        // if isChangeAnalyst false functionality to remain same
        (isChangeAnalyst === false && isCircuitCheck !== '30300') && (
          navigateToSection && (
            <OptionButton
              onClick={navigateToSection}
              option={options}
              className="edit-section"
            >
              {getChangeText(sectionId)}
            </OptionButton>
          ))
      }
      {/* {
        ((isCircuitCheck === 'PostponedCRQ' && isStatus === '3' && network === 'mobile') && (
          (sectionId === 'CHANGE_DETAILS' && network === 'mobile' && (isRiskValue === 'Risk Level 3' || isRiskValue === 'Risk Level 4')) && (
            navigateToSection && (
              <OptionButton
                onClick={navigateToSection}
                option={options}
                className="edit-section"
              >
                {getChangeText(sectionId)}
              </OptionButton>
            )))
        )
        } */}
      {
        viewType === VIEW_TYPE_VIEW_CRQ_WITH_TICKS_AND_ERRORS && (
          <div>
            {
              SvgComponent && (
                <div className="svg-space-maker">
                  {/* // <div className={`svg-tick-or-warning-container ${sectionHasErrors || (isChangeAnalyst === true && isCircuitCheck === '10500' && (sectionId === 'WORK_INFORMATION_ITEMS') && (isInfoItem === 'false' || isInfoItem === null) && ((((changeAnalystCircuitCheckID && userLoggedIn !== changeAnalystCircuitCheckID) || (changeAnalystCircuitCheckID === null))) !== true)) ? 'has-errors' : ' '}`}> */}
                  <div className={`svg-tick-or-warning-container ${sectionHasErrors || (isChangeAnalyst === true && isCircuitCheck === '10500' && (sectionId === 'WORK_INFORMATION_ITEMS') && (isInfoItem === 'false' || isInfoItem === null) && ((((changeAnalystCircuitCheckID && userLoggedIn !== changeAnalystCircuitCheckID) || (!changeAnalystCircuitCheckID) || (changeAnalystCircuitCheckID === null))) !== true)) ? 'has-errors' : ' '}`}>
                    <SvgComponent />
                  </div>
                </div>
              )
            }
          </div>
        )
      }
      <button
        type="button"
        onClick={() => toggleOpen(sectionIndex)}
        className="open-close"
      >
        <div className="svg-container">
          {open ? <ChevronLargeUp /> : <ChevronLargeDown />}
        </div>
      </button>
    </div>
  );
};

SectionSummaryHeaderConnect.propTypes = {
  open: PropTypes.bool,
  toggleOpen: PropTypes.func,
  sectionIndex: PropTypes.number,
  sectionId: PropTypes.string,
  sectionTitle: PropTypes.string,
  navigateToSection: PropTypes.func,
  viewType: PropTypes.string,
  summarySectionRead: PropTypes.bool,
  sectionHasErrors: PropTypes.bool,
  isChangeAnalyst: PropTypes.bool, // isChangeAnalyst PropTypes checking
  formData: formDataShape, // formData PropTypes checking
  // assign: PropTypes.bool,
  userLoggedIn: PropTypes.string,
  changeAnalystCircuitCheckID: PropTypes.string,
  impactValue: PropTypes.string,
  network: PropTypes.string,
  hasReferenceCRQ: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => ({
  isChangeAnalyst: state && state.auth.isChangeAnalyst,
});

const SectionSummaryHeader = connect(
  mapStateToProps,
)(SectionSummaryHeaderConnect); // Wrapping method SectionSummaryHeaderConnect within Connect

SectionSummaryHeader.defaultProps = {
  viewType: VIEW_TYPE_VIEW_CRQ_STANDARD,
};

export { SectionSummaryHeader };
